import { render, staticRenderFns } from "./camprofile.vue?vue&type=template&id=1241e922&"
import script from "./camprofile.vue?vue&type=script&lang=js&"
export * from "./camprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports